// draggableNode.js

export const DraggableNode = ({ type, label }) => {

  const onDragStart = (event, nodeType) => {
    event.target.style.opacity = "0.85";
    event.dataTransfer.setData(
      "application/reactflow",
      JSON.stringify({ nodeType })
    );
    event.dataTransfer.effectAllowed = "move";
  };

  const onDragEnd = (event) => {
    event.target.style.opacity = "1";
  };

  return (
    <div
      className={type}
      onDragStart={(event) => onDragStart(event, type)}
      onDragEnd={onDragEnd}
      draggable
      style={{
        cursor: "grab",
        minWidth: "90px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "6px",
        backgroundColor: "#4f6ef7", // softer blue
        color: "#ffffff",
        fontSize: "14px",
        fontWeight: "500",
        padding: "0 14px",
        border: "1px solid rgba(0,0,0,0.05)",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        transition: "transform 0.1s ease, box-shadow 0.2s ease, background-color 0.2s ease",
        userSelect: "none",
      }}
    >
      <span>{label}</span>
    </div>
  );
};